import styles from "./LoadingPage.module.sass";

import Footer from "./Footer";
import Icon from "colbi_web_ui/lib/components/Icon/Icon";
import LoginFolderConfigs from "./utils";

const LoadingPage = () => {
    const { loadingPageText } = LoginFolderConfigs;
    return (
        <div className={styles["root"]}>
            <div className={styles["full-container"]}>
                <Icon name="no-access" style={{ width: 130, height: 130 }} />
                <h2 className={styles["saft-logo-text"]}>{loadingPageText}</h2>
            </div>
            <Footer className={styles["footer"]} />
        </div>
    );
};

export default LoadingPage;
